import React from "react";

import QuestionBase from "~/modules/SurveysTemplates/SurveyForm/questions/QuestionBase";

const TextQuestion = () => {
  return <QuestionBase />;
};

export default TextQuestion;
